import React from 'react';
export function TopBar() {
  return <div className="sticky top-0 z-50 bg-primary text-black py-2 px-4 text-center font-space-grotesk font-bold text-sm md:text-base shadow-md" data-id="element-273">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-2" data-id="element-274">
        <span data-id="element-275">🏋️</span>
        <span data-id="element-276">COMPRA DIGITAL YA™</span>
      </div>
    </div>;
}